import * as fastDeepEqual from 'fast-deep-equal';

export const deepEqual = (value1: unknown, value2: unknown): boolean => fastDeepEqual(value1, value2);
